
import { defineComponent, onMounted, ref } from 'vue';
import { useField } from 'vee-validate';
import AppFormItem from '@/components/UI/AppFormItem.vue';

export default defineComponent({
  inheritAttrs: false,
  components: { AppFormItem },
  emits: ['update:modelValue'],
  props: {
    modelValue: { type: String, default: '' },
    codeLength: { type: Number, required: true },
    name: { type: String, required: true },
    controlClass: { type: String, default: '' },
    propError: { type: String, default: '' },
  },
  setup(props, { emit }) {
    const { value, errorMessage } = useField(props.name);
    const inputListRef = ref([]);
    const valueList = ref<string[]>([]);
    const currentValue = ref('');

    function updateModalValue() {
      currentValue.value = valueList.value.join('');
      value.value = currentValue.value;
      emit('update:modelValue', currentValue.value);
    }

    function onPaste(paste, index) {
      if (paste.length === props.codeLength) {
        valueList.value = [...paste];
        (inputListRef.value[index] as HTMLElement).blur();
        updateModalValue();
      }
    }

    function onInput(inputValue, index) {
      valueList.value[index] = '';
      // eslint-disable-next-line no-param-reassign
      inputValue = inputValue.replace(/\D/g, '');
      if (inputValue.length === props.codeLength) {
        onPaste(inputValue, index);
        return;
      }
      if (inputValue.length === 1) {
        valueList.value[index] = `${inputValue[0]}`;
        if ((index + 1) !== props.codeLength) {
          (inputListRef.value[index + 1] as HTMLElement).focus();
        } else {
          (inputListRef.value[index] as HTMLElement).blur();
        }
        updateModalValue();
      }
    }

    function onBackspace(index) {
      if (valueList.value[index]) {
        valueList.value[index] = '';
      } else if (index) {
        (inputListRef.value[index - 1] as HTMLElement).focus();
        valueList.value[index - 1] = '';
      }
      updateModalValue();
    }

    function onFocus(index) {
      valueList.value[index] = '';
    }

    onMounted(() => {
      if (inputListRef.value[0]) {
        (inputListRef.value[0] as HTMLElement).focus();
      }
    });

    return {
      errorMessage,
      inputListRef,
      valueList,
      currentValue,
      onInput,
      onBackspace,
      onFocus,
    };
  },
});
